import { CreatedEntity } from '../../../../types/entities';

export interface IVersionUncreated {
  active: boolean;
}

export type IVersion = IVersionUncreated & CreatedEntity & { revision: number };

export enum DetailsPanelStateType {
  Empty = 'Empty',
  ParentDetails = 'ParentDetails',
  ParentAndChildDetails = 'ParentAndChildDetails',
  AddNewParent = 'AddNewParent',
}

export type DetailsPanelState<P, C> =
  | { type: DetailsPanelStateType.Empty }
  | { type: DetailsPanelStateType.ParentDetails; parent: P }
  | { type: DetailsPanelStateType.ParentAndChildDetails; parent: P; child: C }
  | { type: DetailsPanelStateType.AddNewParent };
